import { render, staticRenderFns } from "./HtmlText.vue?vue&type=template&id=0a4954ac&scoped=true&"
import script from "./HtmlText.vue?vue&type=script&lang=js&"
export * from "./HtmlText.vue?vue&type=script&lang=js&"
import style0 from "./HtmlText.vue?vue&type=style&index=0&id=0a4954ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4954ac",
  null
  
)

export default component.exports